<template>
	<div class="h-full flex justify-center">
		<div class="flex flex-col h-full w-full max-w-xl">
			<div class="h-3 grid justify-items-center ">
				<div class="max-w-[1300px]">
					<ejs-progressbar v-if="loading" ref="indeterminate" id="successcontainer" type='Linear' isIndeterminate=true value=20></ejs-progressbar>
				</div>
			</div>
			<div class="grow px-3 sm:px-5 my-3 2xl:my-6">
				<div class="h-full flex flex-col justify-center control-section">
					<offer-request />
					<panel :title="$t('eny.gratulation')" :subtitle="$t('eny.gratulation_text')" addclass="mt-4">
						<rate :amount="amount" :duration="duration" :incl_insurance="incl_insurance"></rate>
						<div class="lg:px-40 pt-7 grid justify-items-center">
							<div class="font-bold">{{$t('eny.confirmation_doc_upload')}}</div>
							<div>{{$t('eny.confirmation_doc_upload2')}}</div>
						</div>
						<div v-if="isLoaded">
							<uploader v-if="isSwiss" :cId="request.id" :title="$t('eny.file_doc_titles.passport')" type="passport" multiple="true"></uploader>
							<uploader v-if="isSwiss && hasPartnerIncome" :cId="request.id" :title="$t('eny.file_doc_titles.passport_partner')" type="passport_partner" multiple="true"></uploader>
							<uploader :cId="request.id" :title="$t('eny.file_doc_titles.salary')" type="salary" multiple="true"></uploader>
							<uploader v-if="hasAddIncome" :cId="request.id" :title="$t('eny.file_doc_titles.salary_add')" type="salary_add" multiple="true"></uploader>
							<uploader v-if="hasPartnerIncome" :cId="request.id" :title="$t('eny.file_doc_titles.salary_partner')" type="salary_partner" multiple="true"></uploader>
							<uploader v-if="!isSwiss" :cId="request.id" :title="$t('eny.file_doc_titles.id')" type="id" multiple="true"></uploader>
							<uploader v-if="!isSwiss && hasPartnerIncome" :cId="request.id" :title="$t('eny.file_doc_titles.id_partner')" type="id_partner" multiple="true"></uploader>
							<uploader v-if="hasBonus" :cId="request.id" :title="$t('eny.file_doc_titles.bonus')" type="bonus" multiple="true"></uploader>
							<uploader v-if="divorced" :cId="request.id" :title="$t('eny.file_doc_titles.divorce')" type="divorce" multiple="true"></uploader>
							<uploader :cId="request.id" :title="$t('eny.file_doc_titles.rent')" type="rent" multiple="true"></uploader>
						</div>
					</panel>
					<!-- Buttons -->
					<div v-if="isLoaded" class="w-full px-10 md:px-20 py-3 2xl:pt-6 flex flex-row justify-center gap-6">
						<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="end">{{$t('eny.submit_loan_request')}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import Panel from "../../Base/Panel.vue";
import OfferRequest from "./Request.vue";
import Rate from "./Rate.vue";
import Uploader from "../../Base/Uploader.vue";
import useNotification from "../../hooks/useNotification";
import { ProgressBarComponent }  from "@syncfusion/ej2-vue-progressbar";

export default {
	name: "CustomerConfirmation",
	components: {
		'panel': Panel,
		'offer-request': OfferRequest,
		'rate' : Rate,
		'uploader': Uploader,
		'ejs-progressbar' : ProgressBarComponent,
	},
	setup() {
		const { showNotification } = useNotification();
		return {
			showNotification,
		}
	},
	methods: {
		end() {
			this.$store.dispatch('user/sendSetPasswordEmail', this.request.user_id)
			.then(() => {
				this.$router.push('/registerConfirmation');
			})
			.catch(() => {
					//console.log("In catch");
			});
		},
	},
	mounted() {
		this.$store.dispatch('customer/update_offer_step', 4);
	},
	computed: {
		...mapGetters('customer', ['request']),
		...mapGetters('user', ['message', 'loading', 'success']),
		amount() {
			return this.request.credit_amount;
		},
		duration() {
			return this.request.credit_duration;
		},
		incl_insurance() {
			return this.request.incl_insurance;
		},
		isSwiss() {
			return this.request.nationality==='ch';
		},
		hasAddIncome() {
			return this.request.has_add_income && this.request.side_job_income>500;
		},
		hasPartnerIncome() {
			return this.request.has_partner_income;
		}, 
		divorced() {
			return (this.request.civil_status==2 || this.request.civil_status==4);
		},
		hasBonus() {
			return this.request.has_add_income;
		},
		isLoaded() {
			return this.request.id;
		}
	},
	watch: {
		message(value) {
			if (value !== '') {
				this.showNotification(value, this.success ? 'info ': 'error', 10);
			}
		},
	}
}
</script>
